module.exports = __webpack_public_path__ + "img/back.58ffb58d.svg";